import React, { useState, useEffect } from "react";
import { StoreDetails } from "../../types";
import StoreInfo from "../../components/StoreInfo/StoreInfo";
import ProductDataUpdater from "../../components/ProductDataUpdater/ProductDataUpdater";
import TelegramSettings from "../../components/TelegramSettings/TelegramSettings";
import PrinterSettings from "../../components/PrinterSettings/PrinterSettings";
import { loadStoreDetails, saveStoreDetails } from "../../utils/storage";
// import { loadTelegramConfig } from '../../utils/telegram';
import "./SettingsPage.css";

interface SettingsPageProps {
    initialStoreDetails?: StoreDetails;
    onStoreDetailsChange?: (details: StoreDetails) => void;
}

const SettingsPage: React.FC<SettingsPageProps> = ({
    initialStoreDetails,
    onStoreDetailsChange,
}) => {
    // Store details state
    const [storeDetails, setStoreDetails] = useState<StoreDetails>(
        initialStoreDetails || {
            name: "Catelyn Pet Shop",
            address: "Bot Tola Railgate (Sector 4), Uttara, Dhaka",
            phone: "01800-072-072",
            email: "catelynpetshop@gmail.com",
            website: "www.catelynpetshop.com",
        }
    );

    // Load data from local storage on component mount
    useEffect(() => {
        const savedStoreDetails = loadStoreDetails();
        if (savedStoreDetails) {
            setStoreDetails(savedStoreDetails);
        }
    }, []);

    // Handle store details change
    const handleStoreDetailsChange = (updatedDetails: StoreDetails) => {
        setStoreDetails(updatedDetails);
        saveStoreDetails(updatedDetails);
        if (onStoreDetailsChange) {
            onStoreDetailsChange(updatedDetails);
        }
    };

    // Edit mode state
    const [isEditing, setIsEditing] = useState(false);

    // Toggle edit mode
    const handleEditToggle = () => {
        setIsEditing((prev) => !prev);
    };

    return (
        <div className="settings-page">
            <h1>Settings</h1>

            <div className="settings-section">
                <h2>Store Information</h2>
                <StoreInfo
                    storeDetails={storeDetails}
                    onStoreDetailsChange={handleStoreDetailsChange}
                    isEditing={isEditing}
                    onEditToggle={handleEditToggle}
                />
            </div>

            <div className="settings-section">
                <h2>Product Data</h2>
                <ProductDataUpdater />
            </div>

            <div className="settings-section">
                <h2>Printer Settings</h2>
                <p className="settings-description">
                    Configure your printer connection and default printing
                    options.
                </p>
                <div className="printer-settings-container">
                    <PrinterSettings />
                </div>
            </div>

            <div className="settings-section">
                <h2>Telegram Integration</h2>
                <p className="settings-description">
                    Configure Telegram integration to automatically send receipt
                    notifications after printing.
                </p>
                <div className="telegram-settings-container">
                    <TelegramSettings onClose={() => {}} />
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;
